import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as api from '../../../api';
import Spinner from '../../../Plateforme/Atoms/Spinner';

const ColorBlock = styled.div`
    width: 50px;
    height: 30px;
    border-radius: 5px;
`

const LineBlock = styled.div`
    position: relative;
	border-bottom: 1px solid #0139d6;
`

const MiniaturesContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    img{
        height: 100px;
        margin-right: 10px;
    }
`

const EditShorlistPage = () => {

    const [event, setEvent] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    //const [allParticipations, setAllParticipations] = useState([]);
    const [candidatingUsers, setCandidatingUsers] = useState([]);
    const [shortlist, setShortlist] = React.useState({valide:[],refuse:[],enattente:[]});

    // get event
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                response.data.displaytype = (response.data.type === "sde" || response.data.type === "sdo") ? "Speed Dating" : "Le FD100";
                console.log(response.data);
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    // get all participations
    useEffect(() => {
        if (!event) return;
        getAllParticipations()
    }, [event])
    function getAllParticipations(){
        api.getParticipatingUsersWithData({ eventId: event._id }).then((response) => {
            console.log("response.data de get all participations");
            console.log(response.data);
            //setAllParticipations(response.data);
            const _selectedCompany = response.data.find(p => p.participation._id === new URLSearchParams(window.location.search).get("cid"));
            setSelectedCompany(_selectedCompany);
            setCandidatingUsers(response.data.filter(participation => participation.participation.type[3] === "b").filter(p => p.candidatures.find(c => c.participationId === _selectedCompany.participation._id) || _selectedCompany.shortlist?.valide.includes(p.participation._id) || _selectedCompany.shortlist?.refuse.includes(p.participation._id) || _selectedCompany.shortlist?.enattente.includes(p.participation._id)))
            setShortlist(_selectedCompany.shortlist || {valide:[],refuse:[],enattente:[]});
        }).catch((error) => {
            console.log(error);
        });
    }

    function save(){
        api.UpsertShortlist(selectedCompany.participation._id,shortlist).then((response) => {
            console.log(response.data);
            // props.onFinnish();
            // props.onBack();
            alert("Shortlist enregistrée");
        }).catch((error) => {
            console.log(error);
        });
    }

    function setStatus(partid,color){
        var newShortlist = {...shortlist};
        if(color === "green"){
            newShortlist.valide.push(partid);
            newShortlist.enattente = newShortlist.enattente.filter(p => p !== partid);
            newShortlist.refuse = newShortlist.refuse.filter(p => p !== partid);
        }else if(color === "purple"){
            newShortlist.enattente.push(partid);
            newShortlist.valide = newShortlist.valide.filter(p => p !== partid);
            newShortlist.refuse = newShortlist.refuse.filter(p => p !== partid);
        }else if(color === "red"){
            newShortlist.refuse.push(partid);
            newShortlist.valide = newShortlist.valide.filter(p => p !== partid);
            newShortlist.enattente = newShortlist.enattente.filter(p => p !== partid);
        }else if(color === "lightgrey"){
            newShortlist.valide = newShortlist.valide.filter(p => p !== partid);
            newShortlist.enattente = newShortlist.enattente.filter(p => p !== partid);
            newShortlist.refuse = newShortlist.refuse.filter(p => p !== partid);
        }
        setShortlist(newShortlist);
    }

    function showCandidature(candidature){
        window.open("/viewcandidatures?cid="+candidature._id, "_blank", "noreferrer");
    }

    function statusToNumber(shorlist,user){
        if(shorlist.valide.includes(user.participation._id)){
            return 3;
        }
        if(shorlist.refuse.includes(user.participation._id)){
            return 0;
        }
        if(shorlist.enattente.includes(user.participation._id)){
            return 2;
        }
        return 1;
    }

    return (
        <div>
            {selectedCompany ? <>
            <br/>
            <h1>{selectedCompany.hsCompany?.properties?.name} [{candidatingUsers.length}]</h1>
            <br/>
            <div style={{flexDirection:"row", alignItems:"center"}} className='flexinfos numbers'>
            <span>{shortlist.valide.length}</span>

            <span>{shortlist.refuse.length}</span>
          
            <span>{shortlist.enattente.length} </span>
            </div>
            <div style={{flexDirection:"row", alignItems:"center"}} className='flexinfos'>
            <span>Confirmé(s)</span>
         
            <span>Refusé(s)</span>
          
            <span>En attente</span>
            </div>
        
            {candidatingUsers.sort((b,a) => statusToNumber(shortlist,a) - statusToNumber(shortlist,b)).map( user => {
                let color = "lightgrey"
                if(shortlist.valide.includes(user.participation._id)){
                    color = "green"
                }
                if(shortlist.refuse.includes(user.participation._id)){
                    color = "red"
                }
                if(shortlist.enattente.includes(user.participation._id)){
                    color = "purple"
                }
                let candidature = user.candidatures.find(c => c.participationId === selectedCompany.participation._id);
                return (
                    <LineBlock key={user.participation._id}>
                        <div className='flexinfos_edit'>
                            <h2 onClick={()=>window.open("ficheadminpopb?eid="+event._id+"&uid="+user.user._id,"_blank","noreferrer")}>{user.participation.userId === "manual user" && <span className='thin tooltip'>ⓘ<span className="tooltiptext">Profil manuellement ajouté</span></span>} {user.hsCompany?.properties?.name || user.participation.data.companyname}</h2>
                            <span className='thin'>Priorité : {candidature?.priorite}</span>
                            <ColorBlock style={{backgroundColor:color}}/>
                            {(candidature?.message || candidature?.projets.length > 0) ?  
                            <span style={{width:"20px"}} className='thin tooltip' onClick={() => showCandidature(candidature)}>
                                ☰
                                <span className="tooltiptext">Voir le contenu de la candidature</span>
                            </span> : <span style={{width:"20px"}}></span>}
                            <select onChange={(e)=>setStatus(user.participation._id,e.target.value)} value={color}>
                                <option value="lightgrey">À traiter</option>
                                <option value="green">Confirmé</option>
                                <option value="red">Refusé</option>
                                <option value="purple">En attente</option>
                            </select>
                        </div>
                        <MiniaturesContainer>
                            {user.portfolio?.map(pf =>
                                <div className='portfolio' key={pf._id}>
                                    {pf.files?.map((file,i) =>
                                        {
                                            if(i === 0 && file.uploaded_path && (file.mimetype === "image/jpeg" || file.mimetype === "image/png"))
                                            {
                                                return <img alt="" key={i} src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.uploaded_path}/>
                                            }
                                        }
                                    )}
                                </div>
                            )}
                        </MiniaturesContainer>
                    </LineBlock>
                )
            })}
            <br/>
            <button onClick={save}>Sauvegarder</button>
            </> : <Spinner/>}
        </div>
    );
};

export default EditShorlistPage;